<template>
  <div
    class="header"
    v-if="extraItem.extras('nav.display') == 1"
    :style="{
      height: pxOrVw(extraItem.extras('nav.model')),
    }"
  >
    <div class="container" style="height: 100%;">
      <div
        class="header-logo"
        v-if=" extraItem.extras('logo.display') == 1 "
        :class="extraItem.extras('logo.size') || 'default'"
      >
        <img class="logo" :src="extraItem.extras('logo.src') || logo" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Head',
  props: ['extras', 'logo'],
}
</script>
